// extracted by mini-css-extract-plugin
module.exports = {"BrandNavApp":"BrandNavApp_BrandNavApp__3c29l","BrandNavAppLink":"BrandNavApp_BrandNavAppLink__2qgwO","brandNavButton":"BrandNavApp_brandNavButton__2MXZz"};